import { render, staticRenderFns } from "./model-notation.vue?vue&type=template&id=b082b14a&scoped=true&"
import script from "./model-notation.vue?vue&type=script&lang=ts&"
export * from "./model-notation.vue?vue&type=script&lang=ts&"
import style0 from "./model-notation.vue?vue&type=style&index=0&id=b082b14a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b082b14a",
  null
  
)

export default component.exports